<template>
  <div class="animated fadeIn vld-parent custom-100" >
    <b-row>
      <b-col sm="12">
        <div class="margin-neg">
          <b-row >
            <b-col md="2" sm="2">
              <b-form-group
                  label="Listenname"
                  label-for="title"
              >
                <b-form-input
                    id="title" type="text"
                    :placeholder="'Listenname'"
                    class="mb-2"
                    :disabled="!editMode"
                    v-model="auftrag.gi_auf_ext"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="2" md="2">
              <span>Zieldatum</span>
              <datetime
                  style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; margin-top: 0.5rem"
                  v-model="auftrag.ziel_datum"
                  input-class="form-control"
                  input-style="color: black;"
                  input-id="date"
                  :disabled="!editMode"
                  :aria-placeholder="formateDate"
                  :phrases="datetimeConfig.phrases"
                  :format="{ day: '2-digit', month: '2-digit', year: 'numeric'}"
                  :min-datetime="datetimeConfig.minTime"
              ></datetime>
            </b-col>
            <b-col md="3" sm="3">
              <b-form-group
                  label="Zuweisung"
                  label-for="allocation"
              >
                <b-form-input
                    id="allocation" type="text"
                    :placeholder="'Zuweisung'"
                    v-model="defaultAllocationText"
                    disabled
                    style="white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col style="padding-bottom: 1rem;" >
              <b-row style="flex-direction: row-reverse; margin-top: 25px">
                <b-button
                          style="margin-top: 5px"
                          variant="primary"
                          class="px-4 mr-3">Zurück
                </b-button>
                <b-button
                    variant="success"
                    style="margin-top: 5px"
                          class="px-4 mr-3"
                    v-if="auftrag.fertig_datum === null"
                >Drucken
                </b-button>
                <b-button
                    variant="success"
                    style="margin-top: 5px"
                          class="px-4 mr-3"
                    v-if="auftrag.fertig_datum === null"
                @click="onFinishTask">Liste Fertigstellen
                </b-button>
                <b-button
                    @click="$refs.print_list_dialog.showModalPreset(
                        bauhofStructure, auftrag.ziel_datum, auftrag.custom_properties, defaultAllocationText, auftrag.gi_auf_ext)"
                    variant="success"
                    style="margin-top: 5px"
                          class="px-4 mr-3"
                    v-if="auftrag.fertig_datum === null">Anpassen
                </b-button>
                <b-button
                    variant="success"
                    style="margin-top: 5px"
                    class="px-4 mr-3"
                    disabled
                    v-if="auftrag.fertig_datum !== null">Fertiggestellt: {{formateFertigDate}}
                </b-button>
              </b-row>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <b-row class="custom-flex-1">
      <b-col sm="12">

      </b-col>
    </b-row>

    <print-list-dialog ref="print_list_dialog" @create-list-planning=""/>

  </div>
</template>

<script>
import {DateTime as LuxonDateTime} from "luxon";
import {Redirect_500, Server_URL} from "@/shared/utils";
import PrintListDialog from "@/views/aufgaben_verwaltung/PrintListDialog.vue";

export default {
  name: "PlanningList",
  components: {PrintListDialog},
  props:{
    responseError: {
      type: Function,
      default: undefined
    },
    showLoader: {
      type: Function,
      default: undefined
    },
    hideLoader: {
      type: Function,
      default: undefined
    },
  },
  data() {
    return {
      auftrag: {
        id: "testid",
        a_nehmer: "Bauhof",
        auftraggeber: "Musterhausen-Public Solutions",
        ziel: "26.01.2019",
        ziel_datum: LuxonDateTime.fromJSDate(new Date()).toISO(),
        gi_hh_aus: "9300300.55511010.2-85500",
        beleg_ex: "2019-0001",
        gi_auf_ext: "Test Sven",
        gi_match: "Forstwirtschaft",
        gi_augr: "0009",
        gi_aufisn: "000038",
        gi_memo: "Test vom Sven",
        email: "info@publicsolutions.de",
        datum: "",
        sachbearbeiter: "Administrator",
        offen: 0,
        quittung: null,
      },
      defaultAllocationText: '',
      datetimeConfig: {phrases: {ok: 'Ok', cancel: 'Abbruch'}, minTime: LuxonDateTime.local().toISO()},
      editMode: false,
      bauhofStructure: null,
    }
  },
  computed: {
    formateDate() {
      if (this.auftrag.ziel_datum === null) {
        return ""
      }
      let event = new Date(this.auftrag.ziel_datum.replace('Z', ''));
      let options = {year: 'numeric', month: '2-digit', day: '2-digit'};
      return event.toLocaleDateString('de-DE', options);
    },
    formateFertigDate() {
      if (this.auftrag.fertig_datum === null) {
        return ""
      }
      let event = new Date(this.auftrag.fertig_datum.replace('Z', ''));
      let options = {year: 'numeric', month: '2-digit', day: '2-digit'};
      return event.toLocaleDateString('de-DE', options);
    },
  },
  methods: {
    onFinishTask() {
      this.showLoader();
      this.$http.post(
          Server_URL + '/auftragsbuch/data/lists/finish/' + this.auftrag.id
      ).then(this.responseOkTrap, this.responseError)
    },
    responseOkTrap(response) {
      this.hideLoader();
      if (response.status === 200 ) {
        this.fertig_datum = LuxonDateTime.local().toISO();
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },
    responseOkFetch(response) {
      if (response.status === 200 && response.body.status === "ok") {
        this.userId = response.body.session.id;
        let data = response.body.data;
        this.auftrag = data.data;
        this.bauhofStructure = data.bauhof_structure;
        console.log(this.bauhofStructure)
        // build default allocation
        let allocationNames = [];
        let allocation = this.auftrag.custom_properties.split(",")
        for (let i = 0; i < allocation.length; i++) {
          let res = JSON.parse(sessionStorage.getItem(allocation[i]));
          if (res !== null) {
            allocationNames.push(res.full_name);
          } else {
            let al = this.getMigrKost(allocation[i], this.bauhofStructure)
            if (al !== '') {
              allocationNames.push(al);
            }
          }
        }
        this.defaultAllocationText = allocationNames.join(", ");
        this.hideLoader();
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },
    getMigrKost(id, data) {
      let res = "";
      if (data === null) {
        return  "";
      }
      for (let i = 0; i < data.length; i++) {
        if (data[i].id === id) {
          res = data[i].text;
          return res;
        }
        res += this.getMigrKost(id, data[i].children)
      }
      return res;
    }
  }
}
</script>

<style scoped>

::v-deep .btn.active > .calendar-item {
  color: black;
  border-color: black;
}
.margin-neg {
  background: #fbfbfb;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 1rem;
}
.form-control {
  color: black;
}
.ic-chevron {
  color: #696969;
  vertical-align: middle;
  cursor: pointer;
  margin: 0px;
}
::v-deep .material-design-icon > .material-design-icon__svg {
  bottom: inherit;
}

::v-deep .refresh-icon > .material-design-icon__svg {
  bottom: auto !important;
}

::v-deep .btn.btn-secondary {
  background: white;
  cursor: pointer;
}
.calendar-item {
  height: 1.5rem;
  width: 1.5rem;
  position: inherit;
  vertical-align: middle;
  border: 2px solid #696969;
  border-radius: 0.25rem;
  display: inline-block;
  align-self: center;
  color: #696969;
}

::v-deep .tree-icon.none {
  display: none;
}
</style>

<style>
.no-select{
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
.ic-chevron > .material-design-icon__svg {
  position: inherit !important;
}
</style>
